import React from "react";
import GameSsoLoginCallBack from "Utils/GameSsoLoginCallBack";
import { useLocation } from "react-router-dom";


const GameSsoCallBackApple = () => {
    const location= useLocation();  
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }
    let query =serchParamsFunc();
    let getGameSvcCd = query.get("gameSvcCd");
    let redirectUri = query.get("redirectUri");
    GameSsoLoginCallBack("apple",getGameSvcCd,redirectUri);
    return(
        <></>
    )
}

export default GameSsoCallBackApple;